const PETAL = "M20,4 C20,9 16,6 13,5 C5,3 0,12 0,22 C0,36 8,46 20,52 C32,46 40,36 40,22 C40,12 35,3 27,5 C24,6 20,9 20,4 Z";

const PETALS = [
  { left: '5%',  dur: '7s',   delay: '0s'    },
  { left: '14%', dur: '9s',   delay: '-3s'   },
  { left: '23%', dur: '6s',   delay: '-1s'   },
  { left: '34%', dur: '8s',   delay: '-5s'   },
  { left: '45%', dur: '7.5s', delay: '-2s'   },
  { left: '55%', dur: '6.5s', delay: '-4s'   },
  { left: '63%', dur: '9s',   delay: '-1.5s' },
  { left: '72%', dur: '7s',   delay: '-6s'   },
  { left: '80%', dur: '8.5s', delay: '-0.5s' },
  { left: '88%', dur: '6s',   delay: '-3.5s' },
  { left: '94%', dur: '9.5s', delay: '-2.5s' },
  { left: '50%', dur: '7.5s', delay: '-7s'   },
];

const SakuraPetals = () => (
  <div className="nf-petals" aria-hidden="true">
    {PETALS.map((p, i) => (
      <span
        key={i}
        className="nf-falling-petal"
        style={{ left: p.left, animationDuration: p.dur, animationDelay: p.delay }}
      >
        <svg viewBox="0 0 40 52" width="14" height="18" xmlns="http://www.w3.org/2000/svg">
          <path d={PETAL} fill="rgba(225,36,84,0.55)" />
          <path d="M20,7 Q21,27 19.5,48" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="1" strokeLinecap="round" />
        </svg>
      </span>
    ))}
  </div>
);

export default SakuraPetals;
